module.exports = function normalize(out, mat) {
  var m44 = mat[15]; // Cannot normalize.

  if (m44 === 0) return false;
  var scale = 1 / m44;

  for (var i = 0; i < 16; i++) {
    out[i] = mat[i] * scale;
  }

  return true;
};